"use strict";
var form = document.querySelector("#form");
var fadeElements = document.querySelectorAll(".fade-in");
var observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.15
};
form.addEventListener("submit", function(e) {
    e.preventDefault();
    window.alert("Thank you! The form has been successfully submitted!");
    form.reset();
});
var fadeObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);
fadeElements.forEach(function(element) {
    fadeObserver.observe(element);
});

//# sourceMappingURL=index.9d3e1154.js.map
